import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const base_url=environment.apiUrl;

@Injectable({
  providedIn: 'root' // Makes this service available app-wide
})
export class DataService {
  private branchListSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private courseListSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);


  constructor(private http: HttpClient) {}

  getCachedBranches(): Observable<any[]> {
    if (this.branchListSubject.value.length > 0) {
      return this.branchListSubject.asObservable();
    }
    else{
      return this.getBranches()
    }
  }

  getCachedCourses(): Observable<any[]> {
    if (this.courseListSubject.value.length > 0) {
      return this.courseListSubject.asObservable();
    }
    else{
     return this.getCourses()
    }
  }

  // Get branch data
  getBranches(): Observable<any[]> {
    return this.http.get<any[]>(`${base_url}contact`).pipe(
      map(data => {
        this.branchListSubject.next(data); 
        return data;
      }),
      catchError(error => {
        console.error('Error fetching branches:', error);
        return [];
      })
    );
  }

  // Get course data
  getCourses(): Observable<any[]> {
    return this.http.get<any[]>(`${base_url}courses`).pipe(
      map(data => {
        this.courseListSubject.next(data); 
        return data;
      }),
      catchError(error => {
        console.error('Error fetching courses:', error);
        return [];
      })
    );
  }


  clearCache() {
    this.branchListSubject.next([]);
    this.courseListSubject.next([]);
  }
}






